import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Avatar, Flex, Image, Stack, Text } from "@mantine/core";
import { IconChartBar, IconChevronRight, IconError404 } from "@tabler/icons-react";

import { StarMiniIcon } from "../../../../assets/icons/IcoStarMini";
import { CampaignBadge } from "../../../CampaignBadge";

export interface CampaignItemProps {
    id: string;
    name: string;
    image?: string;
    dateFrom: string;
    dateTo: string;
    rating: number;
    reviews: number;
    score: number;
}

export const CampaignItem = ({ id, dateTo, dateFrom, rating, reviews, score, name, image }: CampaignItemProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation(["common"]);
    const color = (function () {
        if (score > 80) {
            return "green";
        }
        if (score > 50) {
            return "orange";
        }
        return "red";
    })();
    const handleRedirect = () => {
        navigate(`/campaign/${id}`);
    };

    return (
        <Flex gap={16} style={{ cursor: "pointer" }} onClick={handleRedirect}>
            {image ? (
                <Image radius={8} height={72} width={72} src={image} />
            ) : (
                <Avatar radius={8} size={72}>
                    <IconError404 />
                </Avatar>
            )}
            <Stack spacing={4}>
                <Text size={14} weight={600} style={{ lineHeight: 1.2 }}>
                    {name}
                </Text>
                <Text color="#888E98" size={14} style={{ lineHeight: 1.2 }}>
                    {dateFrom} - {dateTo}
                </Text>
                <Flex wrap="wrap" gap={8}>
                    <CampaignBadge
                        color="rgba(136,142,152,0.12)"
                        textColor="#0D1A33"
                        icon={<StarMiniIcon height={16} width={16} />}
                    >
                        {rating}{" "}
                        <Text ml={5} weight={400} size={14}>
                            {t("campaign_reviews_count", { count: reviews })}
                        </Text>
                    </CampaignBadge>
                    <CampaignBadge color={color} icon={<IconChartBar size={14} />}>
                        {score}
                    </CampaignBadge>
                </Flex>
            </Stack>
            <Flex align="center" ml="auto">
                <IconChevronRight size={20} />
            </Flex>
        </Flex>
    );
};
